import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DEFAULT_API_PAYLOAD, PermissionKeys } from "~/lib/constants";
import { findRecordWithFullAccess, fullname, getInitials } from "~/lib/utils";
import { restApi } from "~/redux/restApi";
import { useSelector } from "~/redux/store";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui";
import AppInfoModal from "./AppInfo";

const UserNav = () => {
  const userId = useSelector((state) => state.persistedReducer.auth.userId);
  const permissions = useSelector(
    (state) => state.persistedReducer.auth.permissions,
  );

  const [getProfile, { data }] = restApi.useLazyProfileQuery();
  const profile = data?.result;

  useEffect(() => {
    if (userId) {
      getProfile({
        ...DEFAULT_API_PAYLOAD,
        id: userId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const [appInfo, setAppInfo] = useState(false);

  const hasAccessManagement = findRecordWithFullAccess(
    permissions,
    PermissionKeys.resourceManagement.rolesAndPermissions.view,
  );

  const menuItems = [
    {
      name: "Change Password",
      link: "/settings/change-password",
    },
    {
      name: "Configuration",
      link: "/settings",
    },
    ...(hasAccessManagement
      ? [
          {
            name: "Access Management",
            link: "/resource/access",
          },
        ]
      : []),
  ];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Avatar className="cursor-pointer bg-neutral-100">
          <AvatarImage src={profile?.avatar?.toString()} alt="avator" />
          <AvatarFallback className="bg-secondary-500 text-primary-500">
            {getInitials(fullname(profile?.firstName, profile?.lastName))}
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {menuItems?.map((item, index) => (
          <Link to={item?.link} key={index}>
            {" "}
            <DropdownMenuItem
              key={index}
              className="group cursor-pointer focus:bg-neutral-200"
            >
              {item?.name}{" "}
            </DropdownMenuItem>
          </Link>
        ))}
        <DropdownMenuSeparator />
        <Link to="/logout">
          <DropdownMenuItem className="group cursor-pointer focus:bg-neutral-200">
            Logout
          </DropdownMenuItem>
        </Link>
        <DropdownMenuItem
          onSelect={(e) => {
            e.preventDefault(); // prevent closing the dropdown
            setAppInfo(true); // open modal
          }}
          className="cursor-pointer"
        >
          App Info
        </DropdownMenuItem>
        <AppInfoModal isOpen={appInfo} onClose={() => setAppInfo(false)} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserNav;
